import { Truck, MapPin } from "lucide-react";
import { formatPrice } from "@/lib/formatPrice";

interface ShippingMethod {
  id: number;
  name: string;
  price: number;
  is_pickup: boolean;
}

interface ShippingMethodSelectorProps {
  methods: ShippingMethod[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

export default function ShippingMethodSelector({
  methods,
  selectedId,
  onSelect,
}: ShippingMethodSelectorProps) {
  return (
    <section>
      <h2 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground mb-6">
        Način dostave
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {methods.map((method) => {
          const isSelected = selectedId === method.id;
          const Icon = method.is_pickup ? MapPin : Truck;
          return (
            <label
              key={method.id}
              className={`relative flex items-center gap-3.5 rounded-xl px-4 py-4 cursor-pointer transition-all duration-200 ${
                isSelected
                  ? "bg-foreground text-white shadow-lg shadow-foreground/10"
                  : "bg-white border border-border/60 hover:border-foreground/20"
              }`}
            >
              <input
                type="radio"
                name="shippingMethod"
                value={method.id}
                checked={isSelected}
                onChange={() => onSelect(method.id)}
                className="sr-only"
              />
              <div className={`size-9 rounded-lg flex items-center justify-center shrink-0 ${
                isSelected ? "bg-white/15" : "bg-muted/50"
              }`}>
                <Icon className={`size-4.5 ${isSelected ? "text-white" : "text-muted-foreground"}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${isSelected ? "text-white" : ""}`}>
                  {method.name}
                </p>
                <p className={`text-xs mt-0.5 ${isSelected ? "text-white/60" : "text-muted-foreground"}`}>
                  {method.is_pickup ? "Općina Tešanj" : "1-3 radna dana"}
                </p>
              </div>
              <span className={`text-sm font-semibold tabular-nums shrink-0 ${
                isSelected
                  ? "text-white"
                  : method.price === 0 ? "text-emerald-600" : ""
              }`}>
                {method.price === 0 ? "Besplatno" : `${formatPrice(method.price)} KM`}
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
